module.exports = __webpack_public_path__ + "static/media/section_1_2_A.53b8170a.png";